import React from 'react';

import { Link, useParams } from "react-router-dom"

import { Title } from "../layouts/Default"

const Error = () => {
    const { code } = useParams()

    const error = {
        403: {
            title: "Error: Access Denied",
            description: <p>You are not authorized to access the requested resource.</p>
        },
        404: {
            title: "Error: Page Not Found",
            description: <p>The page you attempted to visit does not exist.</p>
        },
        "js": {
            title: "Unknown Error",
            description: <p>We weren't able to perform the operation you requested. Our support team has been notified.</p>
        }
    }[code] || {
        title: "Unknown Error",
        description: ""
    }

    return (
        <main id='error' className="flex-grow-1">
            <Title>{error.title}</Title>

            <div className="container mt-3">
                <div className="m-4 m-md-0">
                    { error.description }

                    <Link to="/">Return to main page.</Link>
                </div>
            </div>
        </main>
    )
}

export default Error